const configuredBaseUrl = import.meta.env.VITE_AXON_API_BASE_URL;
const API_BASE_URL = (
  configuredBaseUrl || (import.meta.env.DEV ? "http://127.0.0.1:8000" : "https://api.axonleads.ru")
).replace(/\/$/, "");

export class AuthApiError extends Error {
  constructor(message, status = 0) {
    super(message);
    this.name = "AuthApiError";
    this.status = status;
  }
}

export async function fetchCurrentUser(idToken) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/v1/me`, {
      method: "GET",
      headers: { Authorization: `Bearer ${idToken}` },
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new AuthApiError("Нет связи с AxonLeads. Проверьте интернет и попробуйте ещё раз.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const publicMessage = payload?.error?.message;
    throw new AuthApiError(
      typeof publicMessage === "string" ? publicMessage : "Вход временно недоступен.",
      response.status,
    );
  }
  return payload;
}

export async function exchangeTelegramMiniApp(
  initData,
  firebaseProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID,
) {
  if (typeof initData !== "string" || !initData || initData.length > 8192) {
    throw new AuthApiError("Откройте AxonLeads заново из бота.");
  }
  if (typeof firebaseProjectId !== "string" || !firebaseProjectId) {
    throw new AuthApiError("Конфигурация входа AxonLeads неполна.");
  }
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/v1/auth/telegram/mini-app`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ initData, firebaseProjectId }),
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new AuthApiError("Нет связи с AxonLeads. Проверьте интернет и откройте приложение ещё раз.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const publicMessage = payload?.error?.message;
    throw new AuthApiError(
      typeof publicMessage === "string" ? publicMessage : "Вход через Telegram временно недоступен.",
      response.status,
    );
  }
  if (
    typeof payload?.customToken !== "string"
    || !payload.customToken
    || typeof payload?.nextPath !== "string"
  ) {
    throw new AuthApiError("AxonLeads вернул неполный ответ. Откройте приложение ещё раз.");
  }
  return payload;
}
